import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, House, Compass } from "@phosphor-icons/react";
import Header from "../sections/Header";
import Footer from "../sections/Footer";

export default function NotFound() {
  return (
    <>
      <Header />
      <main
        className="relative overflow-hidden text-white flex items-center justify-center"
        style={{
          minHeight: "80vh",
          background: "linear-gradient(135deg, #0B1F4D 0%, #0F2A6E 55%, #1B6FE0 100%)",
        }}
      >
        <div className="absolute inset-0 grid-bg opacity-15" />
        <div className="absolute -top-32 -left-32 w-[520px] h-[520px] rounded-full blur-3xl blob-drift"
          style={{ background: "rgba(27,111,224,0.35)" }} />
        <div className="absolute -bottom-32 -right-32 w-[520px] h-[520px] rounded-full blur-3xl blob-drift delay-2"
          style={{ background: "rgba(255,255,255,0.05)" }} />

        <div className="relative max-w-3xl mx-auto px-4 lg:px-8 py-24 text-center">
          <div className="inline-flex items-center gap-2.5 text-[11px] uppercase tracking-[0.22em] text-blue-200/85 font-semibold mb-5">
            <Compass size={14} weight="duotone" />
            Wrong turn
          </div>
          <div
            className="font-heading font-bold leading-none"
            style={{
              fontSize: "clamp(96px, 18vw, 200px)",
              letterSpacing: "-0.05em",
              background: "linear-gradient(135deg, #FFFFFF 0%, #7FB1FF 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
            }}
            data-testid="notfound-404"
          >
            404
          </div>
          <h1 className="mt-4 font-heading font-bold text-3xl md:text-4xl tracking-tight" style={{ letterSpacing: "-0.025em" }}>
            This page took a detour.
          </h1>
          <p className="mt-4 text-[15px] text-slate-200/85 font-light max-w-xl mx-auto">
            The page you&apos;re looking for doesn&apos;t exist, has been moved, or is temporarily unavailable. Let&apos;s get you back on track.
          </p>
          <div className="mt-9 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              data-testid="notfound-home-btn"
              className="inline-flex items-center gap-2 h-12 px-7 rounded-md bg-white text-[#0F2A6E] font-semibold hover:bg-blue-50 transition"
            >
              <House size={15} weight="duotone" /> Back to home
            </Link>
            <button
              onClick={() => window.history.length > 1 ? window.history.back() : (window.location.href = "/")}
              data-testid="notfound-back-btn"
              className="inline-flex items-center gap-2 h-12 px-7 rounded-md border border-white/40 text-white font-medium hover:bg-white/10 transition"
            >
              <ArrowLeft size={15} weight="bold" /> Go back
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
